/**
 * Feature Flags
 * 
 * Centralized feature toggles for the application.
 * Set to true to enable, false to disable.
 */

/**
 * Show free shipping progress indicator in cart and add-to-cart feedback.
 * 
 * Currently disabled due to complex shipping rules:
 * - Free shipping only applies to UK customers
 * - Free shipping excludes Printful-fulfilled products
 * 
 * Set to true to re-enable when shipping rules are simplified.
 */
export const SHOW_FREE_SHIPPING_PROGRESS = false;
